<template>
  <div>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-set' class='navbarbtn' v-if='showCanAdvPrintQRCodeDaysSetPower'
        @click='showSetCanAdvPrintQRCodeDaysDialogMD(false)'>
        可提前打印标签天数设置
      </el-button>

      <el-button type='primary' icon='sys sys-sync' class='navbarbtn' v-if='showSyncPower'
        @click='synchronization'>
        同 步
      </el-button>

      <el-button type='primary' icon='sys sys-email' class='navbarbtn' v-if='showSendEmail'
        @click='sendEmail'>
        发送提醒邮件
      </el-button>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.itemNumber' style='width: 125px;' placeholder='物料代码'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.itemName' style='width: 125px;' placeholder='物料名称'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :reduceHeight='200' :seqFixed='true'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='true' operationColumnWidth='90px'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      :expandRowKeys='mainTable.expandRowKeys'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='操作日志' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='showPOOrderLogDialogMD(scope)'><i class='sys sys-log'></i>
          </el-button>
        </el-tooltip>
        <el-tooltip effect='dark' content='材料明细' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='POOrderDocument = scope.data.row.detailDt2; showPOOrderDocumentDialog = true'><i class='sys sys-file'></i>
          </el-button>
        </el-tooltip>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>料号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 350px; text-align: left;'><span style='color: #42426F;'>名称</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>含税单价</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>价税合计</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>税率</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 90px; text-align: left;'><span style='color: #42426F;'>交期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 90px; text-align: left;'><span style='color: #42426F;'>回复交期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>生成标签</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>到货</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>入库</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>退货</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>红字</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>规格</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='ppoe in scope.data.row.detailDt1' :style='mainTableDetail1RowStyle(scope.data.row, ppoe)'
            :key='ppoe.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{ppoe.EntryID}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: blue;'>{{ppoe.ItemNumber}} </span></div>
            <div class='expand-row' style='min-width: 350px; text-align: left;'><span style='color: blue;'>{{ppoe.ItemName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.Qty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.AuxTaxPrice}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{typeof (ppoe.AllAmount) === 'number' ? ppoe.AllAmount.toFixed(2) : ''}} </span></div>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: blue;'>{{ppoe.Cess}}% </span></div>
            <div class='expand-row' style='min-width: 90px; text-align: left;'><span style='color: blue;'>{{ppoe.DevDate.substring(0, 10)}} </span></div>
            <div class='expand-row' style='min-width: 90px; text-align: left;'><span style='color: blue;'>{{ppoe.NewDevDate ? ppoe.NewDevDate.substring(0, 10) : ''}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: blue;'>{{ppoe.CreateQRCodeQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.CommitQty + ppoe.ReturnQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.StockQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.ReturnQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span style='color: blue;'>{{ppoe.RedQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 300px; text-align: left;'><span style='color: blue;'>{{ppoe.ItemModel}} </span></div>
          </div>
        </div>
      </template>
    </Table>

    <el-dialog v-dialogDrag title='操作日志' :visible.sync='showPOOrderLogDialog' width='920px'
      top='10px' lock-scroll>
      <el-table :data='POOrderLog' border height='300px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='LogNo' label='记录号' width='160'>
        </el-table-column>
        <el-table-column prop='Content' label='操作内容' width='400'>
        </el-table-column>
        <el-table-column prop='CreateTime' label='操作时间' width='160'>
          <template #default='scope'>
            {{dateTimeUtil.formartDateTime(new Date(scope.row.CreateTime), 'yyyy-MM-dd HH:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column prop='CreateUserName' label='操作人' width='100'>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog v-dialogDrag title='材料明细' :visible.sync='showPOOrderDocumentDialog' width='670px'
      top='10px' lock-scroll>
      <el-table :data='POOrderDocument' border height='250px'
        :cell-style='{ padding: "0px" }' :header-cell-style='{ padding: "2px" }' size='medium'
        style='margin-top: -35px;'>
        <el-table-column type='index' label='序号' width='60'>
        </el-table-column>
        <el-table-column prop='DocumentName' label='材料名称' width='400'>
          <template #default='scope'>
            <a target='_blank' :href='scope.row.FilePath'>{{scope.row.DocumentName}}</a>
          </template>
        </el-table-column>
        <el-table-column prop='CreateTime' label='操作时间' width='160'>
          <template #default='scope'>
            {{dateTimeUtil.formartDateTime(new Date(scope.row.CreateTime), 'yyyy-MM-dd HH:mm:ss')}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog v-dialogDrag title='可提前打印标签天数设置' :visible.sync='showSetCanAdvPrintQRCodeDaysDialog'
      width='330px' top='10px' lock-scroll>
      <div style='margin-top: -30px;'>
        <div style='margin-top: 0px;'>
          <div class='inputField-label' style='width: 140px; text-align: left'>
            可提前打印标签天数
          </div>
          <el-input-number selectStyle='width: 150px; margin-right: 10px;' size='mini' v-model='canAdvPrintQRCodeDays'
            placeholder=''></el-input-number>
        </div>
        <div class='dialogButtomCenterBtn' style='margin-top: 10px;'>
          <el-button type='primary' @click='setCanAdvPrintQRCodeDays()' size='mini'>保存</el-button>
          <el-button @click='showSetCanAdvPrintQRCodeDaysDialog = false' size='mini'>取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import power from '@/components/sys/Power'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'

export default {
  name: 'POrder',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'PO_POOrder',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        customFilterStr: ' AND 1=0 ',
        Loading: false,

        detail1FilterStr: '',
        itemNumber: '',
        itemName: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      dateTimeUtil: dateTimeUtil,

      showPOOrderLogDialog: false,
      POOrderLog: [],

      showPOOrderDocumentDialog: false,
      POOrderDocument: [],

      showSetCanAdvPrintQRCodeDaysDialog: false,
      canAdvPrintQRCodeDays: 3,

      showSyncPower: false,
      showSendEmail: false,
      showCanAdvPrintQRCodeDaysSetPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    power.setPower(that)

    const rtnObjPromise = axiosHelper.handle('/WebAction/BaseData.User.GetUserSupply', {
    })
    const rtnObj = await rtnObjPromise
    if (rtnObj && rtnObj.error === '000000') {
      if (rtnObj.supplyRoleFlag === '0' && rtnObj.purchaseManagerRoleFlag === '0') {
        that.mainTable.customFilterStr = ''
      } else {
        let customFilterStr = " AND SupplyID IN (''"
        for (let i = 0; i < rtnObj.supplys.length; i++) {
          customFilterStr += ",'" + rtnObj.supplys[i].SupplyID + "'"
        }
        customFilterStr += ')'
        that.mainTable.customFilterStr = customFilterStr
      }
    }
    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.mainTable.detail1FilterStr = ''
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.itemNumber) {
        const itemNumbers = that.mainTable.itemNumber.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNumbers.length; i++) {
          detail1FilterStr += " OR ItemNumber LIKE'%" + itemNumbers[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.itemName) {
        const itemNames = that.mainTable.itemName.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNames.length; i++) {
          detail1FilterStr += " OR ItemName LIKE'%" + itemNames[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.Closed === '1' || data.row.Cancellation === 'True') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '3') {
        return { 'background-color': '#aaaaaa' }
      } else if (data.row.Status === '2' || data.row.Status === '1') {
        if (data.row.DocumentCheckStatus === '1') {
          return { 'background-color': '#00FF7F' }
        } if (data.row.DocumentCommitStatus === '2') {
          return { 'background-color': '#FF4500' }
        } else if (data.row.DocumentCommitStatus === '1') {
          return { 'background-color': '#99ffff' }
        } else if (data.row.UploadDocumentStatus === '1') {
          return { 'background-color': 'orange' }
        }
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 展开行行样式设定方法
    mainTableDetail1RowStyle: function (row, ppoe) {
      if (row.Closed === '1' || row.Cancellation === 'True') {
        return { 'background-color': '#aaaaaa' }
      } else if (row.Status === '3' || ppoe.ErpClosed === '1') {
        return { 'background-color': '#cccccc' }
      }
    },

    // 同步
    synchronization: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const preNow = new Date()
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Sync.SyncData', {
        syncCode: 'PO_POOrder',
        keyValue: ''
      })
      if (rtnObj.error === '000000') {
        const now = new Date()
        that.refreshMainTableContent()
        if (isNaN(rtnObj.msg)) {
          that.$message.success(rtnObj.msg)
        } else {
          that.$message.success('恭喜你，同步成功' + (rtnObj.msg) + '条！' + '共计耗时：' + ((now - preNow) / 1000) + '秒。')
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 发送邮件
    sendEmail: async function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      const supplyID = that.mainTable.selections[0].SupplyID
      const billNos = []
      for (let i = 0; i < that.mainTable.selections.length; i++) {
        if (supplyID !== that.mainTable.selections[i].SupplyID) {
          that.$message.error('请选择同一供应商的数据！')
          return
        }
        billNos.push(that.mainTable.selections[i].BillNo)
      }

      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.POOrderSendEmailToSupply', {
        billNos: billNos,
        supplyID: supplyID
      })
      if (rtnObj.error === '000000') {
        that.$message.success('恭喜你，邮件发送成功！')
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    },

    // 显示采购相关日志
    showPOOrderLogDialogMD: async function (scope) {
      const that = this
      that.POOrderLog = scope.data.row.detailDt3
      that.showPOOrderLogDialog = true
    },

    // 可提前打印标签天数设置弹出框显示方法
    showSetCanAdvPrintQRCodeDaysDialogMD: function () {
      const that = this
      if (that.mainTable.selections.length <= 0) {
        that.$message.error('请选择数据！')
        return
      }
      that.canAdvPrintQRCodeDays = 3
      that.showSetCanAdvPrintQRCodeDaysDialog = true
    },

    // 可提前打印标签天数设置
    setCanAdvPrintQRCodeDays: async function () {
      const that = this
      if (!that.canAdvPrintQRCodeDays || that.canAdvPrintQRCodeDays <= 0) {
        that.$message.error('可提前打印标签天数必须为大于0的数字！')
        return
      }
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebAction/PurchaseManage.POOrder.SetCanAdvPrintQRCodeDays', {
        canAdvPrintQRCodeDays: that.canAdvPrintQRCodeDays,
        poOrders: that.mainTable.selections
      })
      if (rtnObj.error === '000000') {
        that.refreshMainTableContent()
        that.$message.success('设置成功！')
        that.showSetCanAdvPrintQRCodeDaysDialog = false
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
  float: left;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
</style>
